<template>
  <div class="login-judge customer-common">
    <LoginHead title="评委端" />
    <div class="login-handle cus-style">
      <div class="input">
        <van-field
          v-model="phone"
          center
          clearable
          placeholder="手机号码"
          maxlength="11"
          :error="validate.reg_verify_err.phone"
          @change="validate.tel('phone')"
        >
          <!-- <div slot="left-icon" class="inp-ico phone-ico"></div> -->
        </van-field>
        <van-field
          v-model="pwd"
          :type="!switchValues ? 'password' : 'text'"
          center
          clearable
          :error="validate.reg_verify_err.pwd"
          @change="validate.pwd('pwd')"
          placeholder="登录密码"
        >
          <!-- <div slot="left-icon" class="inp-ico pwd-ico"></div> -->
          <template #button>
            <!-- <password-switch :switchValue.sync="switchValues" /> -->
            <img
              :src="
                require(`../../assets/images/login/${
                  switchValues ? '' : 'un'
                }view-ico.png`)
              "
              @click="switchValues = !switchValues"
            />
          </template>
        </van-field>
      </div>
      <div class="login-btn">
        <van-button
          size="large"
          color="linear-gradient(to right, #5DD682, #5AFF8E)"
          :loading="loading"
          @click="fnLogin"
          >登录</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { login } from "../../utils/api/user";
import { validate } from "@/utils/mixin/validate";
import { mapActions } from "vuex";
import LoginHead from "@/components/login/HeadWrap.vue";
// import PwdSwitch from "@/components/login/PwdSwitch.vue";
export default {
  mixins: [validate],
  components: {
    LoginHead
    // ["password-switch"]: PwdSwitch
  },
  data() {
    return {
      phone: "",
      pwd: "",
      switchValues: false,
      loading: false
    };
  },
  methods: {
    ...mapActions(["setUserInfo"]),
    fnLogin() {
      const res = this.validate.tel("phone");
      if (!res) {
        this.$root.$toast.fail("请输入正确的手机号码！");
        return;
      }
      this.loading = true;
      const p = {
        code: this.phone,
        password: this.pwd,
        userType: this.$store.getters.getUserType
      };
      login(p).then((res) => {
        this.loading = false;
        if (res.success) {
          this.setUserInfo(res.data);
          this.$root.$toast.success({
            message: "登录成功",
            duration: 1500,
            onClose: () => {
              this.$router.push("/home/remark");
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.login-judge {
  height: 100%;
  width: 100%;
  .login-handle {
    margin: 0 auto;
    margin-top: 12px;
    width: 335px;
    .input {
      width: 335px;
      border-radius: 5px;
      overflow: hidden;
      margin: 0 auto;
      margin-bottom: 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .pwd-ico {
        background: url("../../assets/images/login/password.png") no-repeat;
      }
      .phone-ico {
        background: url("../../assets/images/login/phone.png") no-repeat;
      }
      .inp-ico {
        width: 55px;
        height: 55px;
        background-size: 20px 20px;
        background-position: center center;
      }
    }
    .login-btn {
      margin-top: 40px;
    }
  }
}
</style>
<style lang="scss">
@import "../../assets/css/customer.scss";
</style>
